import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
import { formatAddress, formatDetails, formatName, formatPerson, formatRegistration, formatWatchlist } from '../utils';
const useOnboardingBusinessInsights = (fpBid, onboardingId) => {
  const $ = _c(6);
  let t0;
  if ($[0] !== fpBid || $[1] !== onboardingId) {
    t0 = getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsOptions({
      path: {
        fpBid,
        onboardingId
      }
    });
    $[0] = fpBid;
    $[1] = onboardingId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = Boolean(fpBid) && Boolean(onboardingId);
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      select: _temp4
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useQuery(t2);
};
export default useOnboardingBusinessInsights;
function _temp(filing, index) {
  return formatRegistration(filing, index.toString());
}
function _temp2(address, index_0) {
  return formatAddress(address, index_0.toString());
}
function _temp3(person) {
  return formatPerson(person);
}
function _temp4(response) {
  const formattedRegistrations = response.registrations.map(_temp);
  return {
    addresses: response.addresses.map(_temp2),
    details: formatDetails(response.details),
    names: response.names.map(name => formatName(name, formattedRegistrations)),
    people: response.people.map(_temp3),
    registrations: formattedRegistrations,
    watchlist: formatWatchlist(response.watchlist, response.caAml)
  };
}